// ─────────────────────────────────────────────────────────────────────────────
// FILE: src/components/HRComponents/MoveStageDrawer.jsx
// ─────────────────────────────────────────────────────────────────────────────
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../../common/apiClient';
import SummaryApi from '../../common/SummaryApi';
import FormOffCanvas from '../ui/FormOffCanvas'; 
import SelectDropdown from '../../customStyles/SelectDropdown'; // 👈 Imported your custom dropdown

const MoveStageDrawer = ({ isOpen, onClose, candidate, onSave }) => {
  const [toStage, setToStage] = useState('');
  const [remarks, setRemarks] = useState('');
  const [isMoving, setIsMoving] = useState(false);

  // Mapped pipeline stages from your stageConfig.js file
  const stageOptions = [
    { label: 'Applied', value: 'applied' },
    { label: 'Resume Screening', value: 'resume_screening' },
    { label: 'Shortlisted', value: 'shortlisted' },
    { label: 'Interview Scheduled', value: 'interview_scheduled' },
    { label: 'Interview Completed', value: 'interview_completed' },
    { label: 'Selected', value: 'selected' },
    { label: 'Offered', value: 'offered' },
    { label: 'Onboarding', value: 'onboarding' },
    { label: 'Hired', value: 'hired' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'On Hold', value: 'on_hold' }
  ];

  // Set the current stage when the candidate is selected or opened
  useEffect(() => {
    if (candidate) {
      setToStage(candidate.currentStage || '');
    }
  }, [candidate, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!toStage) {
      toast.warning('Please select a target pipeline stage');
      return;
    }
    setIsMoving(true);
    try {
      const response = await api.post(SummaryApi.candidateMovestage.url(candidate._id), {
        toStage,
        remarks
      });
      if (response.data.success) {
        toast.success('Hiring pipeline stage altered successfully');
        setRemarks('');
        if (onSave) onSave(); // Triggers parent table refresh
        onClose();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Transition failed');
    } finally {
      setIsMoving(false);
    }
  };

  return (
    <FormOffCanvas isOpen={isOpen} onClose={onClose} title="Transition Candidate Stage">
      <form onSubmit={handleSubmit} className="space-y-5">
        {candidate && (
          <p className="text-xs text-gray-500">
            Current Stage: <span className="capitalize font-bold text-gray-700 bg-gray-100 px-2 py-0.5 rounded">{candidate.currentStage?.replace('_', ' ')}</span>
          </p>
        )}
        
        {/* 👈 Integrated your custom SelectDropdown component for perfect UI consistency */}
        <SelectDropdown
          label="Target Pipeline Stage *"
          options={stageOptions}
          value={toStage}
          onChange={(val) => setToStage(val)}
          valueKey="value"
          labelKey="label"
          searchable={false}
          zIndex={66}
        />

        <div>
          <label className="block text-xs font-bold text-gray-700 mb-1">Workflow Remarks</label>
          <textarea 
            value={remarks} 
            onChange={(e) => setRemarks(e.target.value)} 
            className="w-full border border-gray-300 rounded-lg p-2.5 text-xs outline-none focus:ring-2 focus:ring-red-500" 
            rows={4} 
            placeholder="Transition remarks, screening notes..." 
          />
        </div>

        <button 
          type="submit" 
          disabled={isMoving} 
          className="w-full bg-primary hover:bg-red-700 text-white py-2.5 rounded-lg text-xs font-bold disabled:opacity-50 transition-all"
        >
          {isMoving ? 'Processing Transition...' : 'Update Pipeline State'}
        </button>
      </form>
    </FormOffCanvas>
  );
};

export default MoveStageDrawer;